import styled from "styled-components";

export const FormContainerStyle = styled.div`
   

  .form-cadastro {
    width: 100%;
    margin: auto;   
    background-color: var(--branco) !important;
    border-radius: 0.5rem;
    padding: 1rem;

    .input:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }
`;
